<script setup>
import {ref, computed, onMounted, defineProps} from 'vue';
import {getAvailableDrivers} from "@/services/userService";

// Props que recibe el componente
const props = defineProps({
  selectedDriver: {
    type: Object,
    default: () => ({}),
  },
  onSelectDriver: {
    type: Function,
    default: () => {
    },
  },
});

// Estado local
const drivers = ref([]);
const filterValue = ref('');
const loading = ref(false);
const dropdownVisible = ref(false); // Nueva variable para controlar la visibilidad del dropdown

// Obtiene la lista de conductores
const getDrivers = async () => {
  loading.value = true;
  try {
    drivers.value = await getAvailableDrivers();
  } catch (error) {
    console.error('Error fetching drivers:', error);
  } finally {
    loading.value = false;
  }
};

// Computed para filtrar la lista según el valor ingresado
const filteredDrivers = computed(() => {
  const value = filterValue.value.toLowerCase();
  return drivers.value.filter((driver) => {
    return (
        driver.name.toLowerCase().includes(value) ||
        driver.phone?.toLowerCase().includes(value) ||
        driver.email?.toLowerCase().includes(value)
    );
  });
});

// Selecciona un conductor y notifica al padre
const selectDriver = (driver) => {
  props.onSelectDriver(driver);
  dropdownVisible.value = false; // Ocultar el dropdown
  filterValue.value = ''; // Opcional: Limpiar el campo de búsqueda
};

// Al montar, obtener conductores
onMounted(() => {
  getDrivers();
});
</script>

<template>
  <div class="text-gray-900 dark:text-gray-200">
    <label class="block mb-1 font-semibold">Driver</label>

    <!-- Input de búsqueda -->
    <input
        type="text"
        v-model="filterValue"
        @focus="dropdownVisible = true"
        placeholder="Search by name, phone, or email..."
        class="w-full bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-100 border-gray-300 dark:border-gray-600 focus:ring focus:ring-blue-500 focus:ring-opacity-50 p-3 rounded focus:outline-none border"
    />

    <!-- Mensaje de carga -->
    <div v-if="loading" class="text-sm text-gray-500 dark:text-gray-400 mt-1">
      Loading drivers...
    </div>

    <!-- Listado de conductores filtrados (dropdown) -->
    <div class="relative">
      <ul
          v-if="!loading && dropdownVisible && filterValue.length > 0 && filteredDrivers.length"
          class="absolute w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded shadow-lg z-50 mt-1"
      >
        <li
            v-for="driver in filteredDrivers"
            :key="driver._id"
            class="p-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer transition"
            @click="selectDriver(driver)"
        >
          {{ driver.name }} - {{ driver.phone }}
        </li>
      </ul>
    </div>

    <!-- Mostrar el conductor seleccionado -->
    <div v-if="props.selectedDriver._id" class="mt-2 text-sm text-gray-600 dark:text-gray-400">
      Selected Driver:
      <span class="font-semibold">{{ props.selectedDriver.name }}</span>
    </div>
  </div>
</template>

<style scoped>
/* No se necesitan estilos adicionales si Tailwind está bien configurado. */
</style>
